export default __webpack_public_path__ + "static/media/99t.3d74de97.jpg";